<template>
	<div>

	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		components: {},
		mounted() {
			if (window.location.href.indexOf('localhost') >= 0) {
				this.$router.push({
					name: 'Invitation'
				})

			} else {
				// console.log(777, process.env.VUE_APP_BASE_API2.indexOf('test'))
				let https = process.env.VUE_APP_BASE_API2.indexOf('test') >= 0 ? 'https://channel.jgz555.com' :
					'https://chan.jgz555.com/';
				https = https + `/#/pages/other/download?language=${localStorage.getItem('bigLang') || 'CHINESE'}`
				window.location.href = https
			}

		},
		watch: {},
		methods: {}
	}
</script>

<style lang='less'>
</style>